import React, { useCallback, useEffect, useState } from 'react';
import './App.css';
import './Font.css';
import './Layout.css';
import './cssConfig/MonthFormConfig.css';
import './cssConfig/TopbarConfig.css';
import { Route, BrowserRouter, Routes } from 'react-router-dom';
import Signin from './containers/homepage/signin/Signin';
import Signup from './containers/homepage/signup/Signup';
import Home from './containers/homepage/home/Home';
import { ModuleRegistry, AllCommunityModule } from 'ag-grid-community';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import ToastContainer from './components/common/Toast';
import { SessionExpiredModal } from './components/common/modal/SessionExpiredModal';
import { setSessionExpiredModalHandler } from './utils/axios/axiosInterceptor';
import { setSessionErrorModalHandler, handleGlobalError } from './utils/auth/sessionErrorHandler';
import { clearStoredTokens } from './utils/auth/authConfig';
import { useSessionTimer } from './hooks/useSessionTimer';


ModuleRegistry.registerModules([AllCommunityModule]);


function App() {
  const [isSessionModalOpen, setIsSessionModalOpen] = useState(false);

  const handleSessionExpired = useCallback((_message?: string) => {
    setIsSessionModalOpen(true);
  }, []);

  const setScreenHeight = () => {
    document.documentElement.style.setProperty('--doc-height', `${window.innerHeight}px`);
  }

  useEffect(() => {
    setScreenHeight();
    window.addEventListener('resize', setScreenHeight);

    const hideErrorOverlay = () => {
      const errorOverlay = document.querySelector('[data-react-error-overlay]') ||
                          document.querySelector('iframe[src*="react-error-overlay"]') ||
                          document.querySelector('div[style*="position: fixed"][style*="z-index: 999999"]');
      if (errorOverlay) {
        (errorOverlay as HTMLElement).style.display = 'none';
      }
    };

    hideErrorOverlay();
    const interval = setInterval(hideErrorOverlay, 100);

    return () => {
      window.removeEventListener('resize', setScreenHeight);
      clearInterval(interval);
    };
  }, [])

  useEffect(() => {
    setSessionExpiredModalHandler(handleSessionExpired);
    setSessionErrorModalHandler(handleSessionExpired);

    const handleErrorEvent = (event: ErrorEvent) => {
      handleGlobalError(event, 'global-error');
    };

    const handleRejectionEvent = (event: PromiseRejectionEvent) => {
      handleGlobalError(event, 'global-error');
    };

    window.addEventListener('error', handleErrorEvent);
    window.addEventListener('unhandledrejection', handleRejectionEvent);

    return () => {
      window.removeEventListener('error', handleErrorEvent);
      window.removeEventListener('unhandledrejection', handleRejectionEvent);
    };
  }, [handleSessionExpired]);

  useSessionTimer(handleSessionExpired);

  const handleSessionModalConfirm = () => {
    clearStoredTokens();
    window.location.assign("/signin");
  };

  return (
    <BrowserRouter basename='/'>
      <Routes>
        <Route path="/signin" element={<Signin />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/" element={<Home />} />
      </Routes>
      <ToastContainer />
      <SessionExpiredModal
        isOpen={isSessionModalOpen}
        onConfirm={handleSessionModalConfirm}
      />
    </BrowserRouter>
  );
}

export default App;
